/** One `Formaten` badge: a format a stuk exists in, and the roles of the representaties behind it. */
export interface FormatBadge {
    /** An extension, or the analog label. */
    readonly label: string;
    /** Already translated and deduplicated; empty when no representatie behind this format declares one. */
    readonly roles: string[];
    /** HFBD-10: whether this format is (one of) the stuk's access representatie(s) — where the quick-preview eye icon renders. */
    readonly isAccess: boolean;
}

/**
 * `unknown` is deliberately not the same as `ready` with no badges: a stuk with no representaties shows a
 * dash, while a lookup that could not be trusted — a truncated response or a failed request — shows nothing
 * at all. Wrong badges are worse than absent ones.
 */
export interface StukFormats {
    readonly status: 'loading' | 'ready' | 'unknown';
    readonly badges: FormatBadge[];
    /** HFBD-10: the access representatie's own record id — what the quick-preview icon opens — `null` if it has none. */
    readonly previewRecordId: string | null;
}

export const LOADING_FORMATS: StukFormats = { status: 'loading', badges: [], previewRecordId: null };
export const UNKNOWN_FORMATS: StukFormats = { status: 'unknown', badges: [], previewRecordId: null };
